import axiosBase from 'axios'

const api = axiosBase.create({
    baseURL: 'https://1csgxk1mh6.execute-api.us-east-2.amazonaws.com/dev',

    timeout: 5000,
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', }
});

export default api